module.exports = __webpack_public_path__ + "img/questionnaire.7b178d69.png";